import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("avida_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const clean = (s) => String(s).replace(/^Value error,\s*/i, "");
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return clean(detail);
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? clean(e.msg) : JSON.stringify(e))).join(" · ");
  return JSON.stringify(detail);
}

export default api;
